<template>
  <div id="vue-app">
      <div class="container mt">
           <div tabindex="0" role="alert" class="confirmation-container" id="confirm">
               <div class="confirmation" v-if="confirm">
                <p>Your account information has been updated.</p>
                <router-link to="/available-properties/">Back to Available Properties</router-link>

               </div>
              

          </div>
      <div class="form-container" v-if="!confirm">
          <div tabindex="0" role="alert" class="error-container" id="error">
          <div class="error" v-if="error">
              <p>There was an error with your submission. Check that you have filled out all required fields.</p>
          </div>
          </div>
         
          <form id="registerForm">
              <div class="form-item">
                <p class="warning" tabindex="0" role="alert">Please enter your first name</p>
                <label for="first_name">First Name<sup>*</sup></label>
                <input type="text" value="firstName" name="first_name" id="first_name" v-model="firstName" required>
            </div>
            <div class="form-item">
                <p class="warning" tabindex="0" role="alert">Please enter your last name</p>
                <label for="last_name">Last Name<sup>*</sup></label>
                <input type="text" value="lastName" name="last_name" id="last_name" v-model="lastName" required>
            </div>
            <div class="form-item">
                <label for="last_name">Organization Name</label>
                <input type="text" value="organization" name="organization" id="organization" v-model="organization">
            </div>
            <div class="form-item">
                <label for="address">Street Address</label>
                <input type="text" value="address" name="address" id="address" v-model="address">
            </div>
            <div class="form-item">
                <label for="apt">Apt #</label>
                <input type="text" value="apt" name="apt" id="apt" v-model="apt">
            </div>
            <div class="form-item">
                <label for="city">City</label>
                <input type="text" class="" name="city" id="city" v-model="city">
            </div>
            <div class="form-item">
                <label for="state">State</label>
                <input type="text" class="" name="state" id="state" v-model="state">
            </div>
            <div class="form-item">
                <label for="zip">Zip</label>
                <input type="number" class="" name="zip" id="zip" v-model="zip">
            </div>
            </form>
            <div class="application-button-container">
            <button v-on:click="update">Update</button>
                            <double-bounce v-if="loading"></double-bounce>

            </div>
        </div>
        </div>
  </div>
</template>

<script>
import axios from 'axios';
import {DoubleBounce} from 'vue-loading-spinner';


export default {
  name: 'ApplicationUpdate',


  components: {
      DoubleBounce,
  },


  data() {
    return {
        userData: {},
        firstName: '',
        lastName: '',
        organization: '',
        address: '',
        apt: '',
        city: '',
        state: '',
        zip: '',
        username: '',
        password: '',
        number: '',
        street: '',
        confirm: false,
        error: false,
        requiredFields: {},
        loading: false,
    }
  },
  created() {
        window.scrollTo(0,0);
        // Get user information
        axios.post('/wp-json/HCLRC/v1/get-public-user-profile')
        .then(res => {
            if (res.data.data.message == 'INVALID USER') {
                this.$router.push({path: '/available-properties/login', query: {fromApplication: true, redirect: '/available-properties/applications/' + this.$route.params.property_id }});

            }
            console.log(res);
            this.$set(this, 'loading', false);
            this.$set(this, 'userData', res.data.data.data);
            this.$set(this, 'firstName', this.userData.first_name);
            this.$set(this, 'lastName', this.userData.last_name);
            this.$set(this, 'organization', this.userData.organization);
            this.$set(this, 'number', this.userData.number);
            this.$set(this, 'street', this.userData.street);
            this.$set(this, 'apt', this.userData.apt);
            this.$set(this, 'city', this.userData.city);
            this.$set(this, 'state', this.userData.state);
            this.$set(this, 'zip', this.userData.zip);
            
            if (this.number !== null) {
                this.$set(this, 'address', this.number + ' ' + this.street);

            }

        })
        .catch(function (error) {
            // if an error occurs, print that error
            console.log(error);

        });

  },
  methods: {
      update() {
            this.$set(this, 'loading', true);

          var addressArray = this.address.split(" ");
          this.number = addressArray[0];
          addressArray.shift();
          var street = '';
          for (var item of addressArray) {
              street += item + ' ';
          }
          this.street = street;

          // Get required fields 
          this.$set(this, 'requiredFields', {
              'first_name': this.firstName, 
              'last_name': this.lastName,
            });



           this.$set(this, 'error', false);
            $('.form-item').each(function() {
                $(this).removeClass('warning');
            })

            // Check and make sure that all required fields are filled out
            for (var item in this.requiredFields) {
                if (this.requiredFields[item] == '') {

                    // Display generic error message and scroll it into view
                    this.$set(this, 'error', true);
                    this.$set(this, 'loading', false);

                    window.scrollTo(0,0);
                    document.getElementById('error').focus();
                    $('#' + item).closest('.form-item').addClass('warning');
                    
                }
            }
            

          if (!this.error) {
              axios.post('/wp-json/HCLRC/v1/update-public-user-profile', {
                first_name: this.firstName, last_name: this.lastName, number: this.number, unit: this.apt, street: this.street, city: this.city, state: this.state, zip: this.zip, organization: this.organization
                }).then(res => {
                    console.log(res);
                    this.$set(this, 'loading', false);
                    if (res.data.data.status != "ERROR") {
                        this.$set(this, 'confirm', true);
                        window.scrollTo(0,0);
                        document.getElementById('confirm').focus();
                        
                    } else {
                        this.$set(this, 'error', 'There was a problem with your submission.');
                        window.scrollTo(0,0);
                        document.getElementById('error').focus();
                        
                    }
                
            })
            .catch(function (error) {
                // if an error occurs, print that error
                console.log(error);

            }); 
          } 
          
      },
      getRedirect() {
            if (window.location.search != '') {
                var queries = window.location.search.substring(1);
                if (this.$parent.includes(queries, 'redirect=')) {
                    var queryItems = queries.split('&');
                    var redirect;
                    for (var item of queryItems) {
                        var keyValuePair = item.split("=");
                        if (keyValuePair[0] == 'redirect') {
                            return decodeURIComponent(keyValuePair[1]);
                        }
                    }
                }
            }
            return false;
      },
  }
}
</script>
<!-- styling for the component -->
<style lang="scss">
.error {
    background-color: #dc3b43;
    padding: 1rem;
    margin-bottom: 2rem;
    p {
        font-weight: 600;
        color: #fff;
        margin-bottom: 0;
    }
}
.confirmation {
    border: 3px solid rgba(37, 114, 130, .3);
    padding: 2rem !important;
    text-align: center;
   
    a {
        font-size: 1.25rem;
        font-family: 'din-2014';
        font-weight: 600;
        padding: .75rem 3rem;
        background-color: #dc3b43;
        color: #fff !important;
        font-size: 1rem;
        margin: 1rem;
        cursor: pointer;
        transition: all .5s;

        &:hover, &:focus, &.active {
            background-color: #A12127;
        }
    }

}
#registerForm {
    .form-item {
        margin-bottom: .5rem;
    }
}
.form-container {
    text-align: center;
    form {
        display: flex;
        flex-direction: column;
        width: 50%;
        margin: 0 auto;
        text-align: left;
        @media screen and (max-width: 768px) {
            width: 90%;
        }
        label {
            font-weight: 600;
            margin-bottom: 0;
            text-align: left;
        }
        input {
            font-family: "neue-haas-unica";
            border: 1px solid rgba(37, 114, 130, .3);
            margin-bottom: 1rem;
            font-size: 1rem;
            width: 100%;
        }
    }

    button {
        font-size: 1.25rem;
        font-family: 'din-2014';
        font-weight: 600;
        padding: .75rem 5rem;
        background-color: #dc3b43;
        color: #fff;
        font-size: 1rem;
        margin-bottom: 1rem;
        cursor: pointer;
        transition: all .5s;

        &:hover, &:focus, &.active {
            background-color: #A12127;
        }
    }
    a {
        display: block;
        text-transform: none;
        color: #dc3b43;
    }
}
.form-item {
        p.warning {
            display: none;
        }
        &.warning {
            border: 1px solid #DC3B43;
            padding: 1rem;
            p.warning {
                display: block;
                font-weight: 700;
                color: #DC3B43;
            }
        }
}
.application-button-container {
    position: relative;
    .spinner {
        margin: 0 auto;
        position: relative !important;
        top: 1rem;
    }

}

</style>


// WEBPACK FOOTER //
// src/components/Application/ApplicationUpdate.vue